import { format, parseISO } from 'date-fns';
import { Loader2 } from 'lucide-react';
import { forwardRef, useCallback } from 'react';

import { useApproveManualPayments } from '~entities/payment/api/approve-manual-payments';

import { Button } from '~shared/shadcn/ui/button';

interface RetryOrCollectPaymentProps {
  invoiceId: string;
  invoiceDate: string;
  buttonText: string;
}

export const RetryOrCollectPayment = forwardRef<
  HTMLButtonElement,
  RetryOrCollectPaymentProps
>(({ invoiceId, invoiceDate, buttonText }, ref) => {
  const mutation = useApproveManualPayments();

  const handleApprove = useCallback(async () => {
    try {
      await mutation.mutateAsync({
        invoiceId: [invoiceId],
        date: format(parseISO(invoiceDate), 'yyyy-MM-dd'),
      });
    } catch (error) {
      console.error('Error approving payments:', error);
    }
  }, [invoiceDate, invoiceId, mutation]);

  return (
    <Button
      variant='outline'
      onClick={() => handleApprove()}
      ref={ref}
      disabled={mutation.isPending}
    >
      {mutation.isPending && <Loader2 className='size-4 animate-spin' />}
      {buttonText}
    </Button>
  );
});

RetryOrCollectPayment.displayName = 'RetryOrCollectPayment';
